import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { isClient } from "../global";
import { hasLocalStorage } from "../utils/features";

const useReferralCode = () => {
  const [referralCodeId, setReferralCodeId] = useState<string | undefined>(
    undefined
  );
  const [referralName, setReferralName] = useState<string | undefined>(
    undefined
  );
  const [referralValue, setReferralValue] = useState<string | undefined>(
    undefined
  );
  // Get the cookie with the referral code ID
  useEffect(() => {
    if (isClient()) {
      let c = Cookies.get("ref_meta");
      if (c === undefined) {
        // Prioritise the cookie but if nothing check in local storage
        if (hasLocalStorage()) {
          const ls = localStorage.getItem("ref_meta");
          if (ls) {
            c = ls;
          }
        }
      }
      if (!c) {
        return;
      }
      try {
        const data = c.split(",");
        // Validate the data looks correct
        if (
          data[0].startsWith("rfl_code__") &&
          data.length > 1 &&
          data[1].length > 0
        ) {
          setReferralCodeId(data[0]);
          setReferralName(data[1]);
          setReferralValue(data[2]);
          // pop the data in localstorage for safer keeping
          if (hasLocalStorage()) {
            localStorage.setItem("ref_meta", c);
          }
        }
      } catch (err) {
        // fail silently
      }
    }
  }, []);
  return { referralCodeId, referralName, referralValue };
};

export default useReferralCode;
